module.exports = __webpack_public_path__ + "static/media/digital-marketing-fpt-service.edf3be96.png";